import React from "react";

// Réplica en cliente de backend/validators/EscalaCalificacionValidator.php
// (Etapa 4/6): escala 1-5 + "N/O", justificación y evidencia obligatorias
// SOLO para 1 y 5 — no para 2, a diferencia de PerformanceEvaluation.js
// (frontend legacy), que por una divergencia ya documentada
// (docs/matriz-trazabilidad.md C2) exige justificación también para 2.
// Este componente implementa la regla de negocio tal como está en el
// DOCX, no la particularidad del frontend legacy.
//
// Esto es SOLO validación de UX en cliente — el backend
// (CalificacionService, Etapa 7) vuelve a validar todo exactamente igual
// y es la única fuente de verdad; este componente nunca decide si algo
// "quedó guardado".

const OPCIONES = [
  { valor: "", etiqueta: "Seleccione calificación" },
  { valor: "1", etiqueta: "1 - No cumple" },
  { valor: "2", etiqueta: "2 - Cumplimiento parcial" },
  { valor: "3", etiqueta: "3 - Cumple lo esperado" },
  { valor: "4", etiqueta: "4 - Supera lo esperado" },
  { valor: "5", etiqueta: "5 - Desempeño sobresaliente" },
  { valor: "N/O", etiqueta: "No observado (N/O)" },
];

export function exigeJustificacionYEvidencia(valor) {
  return valor === "1" || valor === "5";
}

export function validarCalificacion({ valor, justificacion, evidenciaTexto }) {
  const errores = [];

  if (valor === "" || valor === undefined || valor === null) {
    return errores; // ausente no es un error de este componente, ver EscalaCalificacionValidator.php
  }

  if (valor !== "N/O" && !["1", "2", "3", "4", "5"].includes(valor)) {
    errores.push("Calificación inválida.");
    return errores;
  }

  if (exigeJustificacionYEvidencia(valor)) {
    if (!justificacion || !justificacion.trim()) {
      errores.push("La justificación es obligatoria para esta calificación.");
    }
    if (!evidenciaTexto || !evidenciaTexto.trim()) {
      errores.push("La evidencia es obligatoria para esta calificación.");
    }
  }

  return errores;
}

/**
 * @param {object} props
 * @param {string} props.valor "1".."5", "N/O", o "".
 * @param {(valor: string) => void} props.onValorChange
 * @param {string} props.justificacion
 * @param {(texto: string) => void} props.onJustificacionChange
 * @param {string} props.evidenciaTexto
 * @param {(texto: string) => void} props.onEvidenciaChange
 * @param {boolean} [props.deshabilitado]
 */
export default function RatingInput({
  valor,
  onValorChange,
  justificacion,
  onJustificacionChange,
  evidenciaTexto,
  onEvidenciaChange,
  deshabilitado = false,
}) {
  const requiereDetalle = exigeJustificacionYEvidencia(valor);
  const errores = validarCalificacion({ valor, justificacion, evidenciaTexto });

  return (
    <div className="fase2-rating-input">
      <select
        value={valor || ""}
        onChange={(e) => onValorChange(e.target.value)}
        disabled={deshabilitado}
        aria-label="Calificación"
      >
        {OPCIONES.map((opcion) => (
          <option key={opcion.valor} value={opcion.valor}>
            {opcion.etiqueta}
          </option>
        ))}
      </select>

      {requiereDetalle && (
        <div className="fase2-rating-detalle">
          <label>
            Justificación
            <textarea
              value={justificacion || ""}
              onChange={(e) => onJustificacionChange(e.target.value)}
              disabled={deshabilitado}
              placeholder="Explique la calificación otorgada"
              rows={2}
            />
          </label>
          <label>
            Evidencia
            <textarea
              value={evidenciaTexto || ""}
              onChange={(e) => onEvidenciaChange(e.target.value)}
              disabled={deshabilitado}
              placeholder="Describa la evidencia que soporta la calificación"
              rows={2}
            />
          </label>
        </div>
      )}

      {errores.length > 0 && (
        <ul className="fase2-rating-errores" role="alert">
          {errores.map((error, idx) => (
            <li key={idx}>{error}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
